import {
  TOGGLE_ITEM_MODAL,
  CHANGE_ITEM_MODAL_TAB,
  OPEN_MAIN_MODAL,
  CLOSE_MAIN_MODAL,
} from "./constants";

export const openMainModal = (
  content,
  title,
  closeCb = null,
  btnLabel = "OK",
  btnSecondaryCb,
  btnSecondaryLabel
) => (dispatch) => {
  dispatch({
    type: OPEN_MAIN_MODAL,
    payload: {
      content,
      title,
      closeCb,
      btnLabel,
      btnSecondaryCb,
      btnSecondaryLabel,
    },
  });
};

export const closeMainModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_MAIN_MODAL,
  });
};

export const toggleItemModal = (itemModalActiveTab, activeTeamID) => (
  dispatch
) => {
  dispatch({
    type: TOGGLE_ITEM_MODAL,
    payload: {
      itemModalActiveTab,
      activeTeamID,
    },
  });
};

export const changeItemModalTab = (itemModalActiveTab) => (dispatch) => {
  dispatch({
    type: CHANGE_ITEM_MODAL_TAB,
    payload: {
      itemModalActiveTab,
    },
  });
};
